import React, { useState, useEffect } from 'react';
import {Link, useLocation, useParams} from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import {
  Button,
  Card,
  Row,
  Col,
  InputGroup,
  Form
} from "react-bootstrap";

import {
  CustomPaging,
  PagingState,
  SortingState,
  SearchState,
  FilteringState,
  IntegratedFiltering,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
  SearchPanel,
  Toolbar,
  TableColumnResizing,
  TableFilterRow,
} from '@devexpress/dx-react-grid-bootstrap4';

import {Loading} from 'components/Loading/loading';

import AuditIndex from 'views/Audit/Index.js';
import { useLocalStorage } from 'react-use';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';


const SORT_FIELD_MAP = {
  auditee: `auditee.SCOPE_ID`,
  instrument: `instrument.INSTRUMENT_NAME`,
};

export default function Index() {

  //document.body.style.zoom = "80%";

  const [listYear, setListYear] = useState([]);

  const {employeeId} = useParams();
  const {pathname} = useLocation();
  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert();
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [pageSizes] = useState([50]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sorting, setSorting] = useState([{ columnName: 'SCHEDULE_ID', direction: 'desc' }]);
  const [columns] = useState([
    { name: 'action', title: 'Action', getCellValue: (row) => (
      <Link to={`${pathname}/${row.SCHEDULE_ID}/proofs`}>
        <Button variant="info" size="sm">Detail</Button>
      </Link>
    )},
    { name: 'SCHEDULE_ID', title: 'ID' },
    { name: 'auditee', title: 'Auditee', getCellValue: row => row?.auditee?.department?.DEPT_NAME ?? `n-a` },
    { name: 'START_DATE', title: 'Year', getCellValue: row => moment(row?.START_DATE).format('YYYY') ?? `n-a`  },
    {
      name: 'instrument', title: 'Instrument',
      getCellValue: row => (row?.instrument?.standard)
      ? `${row.instrument.standard.STANDARD_NAME} - ${row.instrument.INSTRUMENT_NAME}`
      : `n-a`
    },
    { name: 'SCHEDULE_STATUS', title: 'Status' },
  ]);

  const [defaultColumnWidths] = useState([
    { columnName: 'SCHEDULE_ID', width: 70 },
    { columnName: 'auditee', width: 270 },
    { columnName: 'START_DATE', width: 100 },
    {columnName: 'instrument', width: 460 },
    {columnName: 'SCHEDULE_STATUS', width: 90 },
    {columnName: 'action', width: 90 },
  ]);
  const [columnWidths, setColumnWidths] = useState(defaultColumnWidths);

  const [searchValue, setSearchValue] = useState('');
  const [tempSearch, setTempSearch] = useState('');

  const getRowId = row => row.SCHEDULE_ID;

  const fetchSchedules = async () => {

    setLoading(true);

    try {

      const orderBy = sorting?.[0];
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}schedules`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          expand: `auditee.department,instrument.standard`,
          sort: `-AUDIT_SCHEDULE.SCHEDULE_ID`,
          page: currentPage + 1,
          'per-page': pageSize,
          'search': searchValue,
          'year': years,
          'scope': scope,
          AUDITEE_TEAMS__EMP_ID: employeeId,
          sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
        }
      });

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);
      setLoading(false);

    } catch (error) {
      setLoading(false);
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const fetchListYear = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}schedule/list-year`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        }
      });
      setListYear(response.data.result)

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setSearchValue(event.target.value);
    }
  };

  const [years, setYears] = useState('');
  const [scope, setScopes] = useState('');

  // TableFilterRow ini untuk FilterRow
  const [filteringStateColumnExtensions] = useState([
    { columnName: 'action', filteringEnabled: false },
  ]);

  const [filter, setFilter] = useState([]);

  const onFilterChange = (filters) => {
    setFilter(filters);
  };

  useEffect(fetchSchedules, [searchValue, pageSize, currentPage, sorting]);

  useEffect(fetchListYear, []);
  return (
    <AuditIndex>
      <Row>
        {swal}
        <Col md="12">
          <Card>
            <Card.Header>
              <Card.Title as="h4">Audit List</Card.Title>
              <Card.Body>
                <Row>
                  Additional Filtering
                </Row>
                <Row>
                  <Form.Group as={Col}>
                    <Form.Control className="w-100" name="YEAR_ID" as="select" onChange=
                      {e => {
                        setYears(e.target.value);
                      }}
                    >
                      <option>Select Years...</option>
                      {listYear && listYear.map((year, key) => (
                      <option key={key} value={year.VALUE?year.VALUE:''}>
                        {year.YEAR}
                      </option>
                      ))}
                      {/* <option>Select Years...</option>
                      <option value='2021'>2021</option>
                      <option value='2022'>2022</option>
                      <option value='2023'>2023</option>
                      <option value='2024'>2024</option>
                      <option value='2025'>2025</option>
                      <option value=''>All</option> */}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Control className="w-100" name="SCOPE_ID" as="select" onChange=
                      {e => {
                        setScopes(e.target.value);
                      }}
                    >
                      <option>Select Scope...</option>
                      <option value='1'>Program Studi</option>
                      <option value='2'>Fakultas</option>
                      <option value='3'>Department</option>
                      <option value='5'>Univ</option>
                      <option value=''>All</option>
                    </Form.Control>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Button onClick={fetchSchedules}>Show</Button>
                  </Form.Group>
                </Row>
              </Card.Body>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md="4"></Col>
                <Col md="4"></Col>
                <Col md="4">
                <Form.Group>
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="Search...."
                    onChange={(event) => setTempSearch(event.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <InputGroup.Text>
                    <i className="nc-icon nc-zoom-split"
                      style={{
                        cursor: "pointer",
                        transition: "color 0.3s ease, transform 0.2s ease"
                      }}
                      onClick={() => setSearchValue(tempSearch)}
                      onMouseOver={(e) => (e.target.style.color = "blue")}
                      onMouseOut={(e) => (e.target.style.color = "")}>
                    </i>
                  </InputGroup.Text>
                </InputGroup>
                </Form.Group>
                </Col>
              </Row>
              <Grid
                rows={rows}
                columns={columns}
                getRowId={getRowId}
              >

                {/* <SearchState onValueChange={setSearchValue} /> */}

                <SortingState
                  sorting={sorting}
                  onSortingChange={setSorting}
                />

                <PagingState
                  currentPage={currentPage}
                  onCurrentPageChange={setCurrentPage}
                  pageSize={pageSize}
                  onPageSizeChange={setPageSize}
                />
                <CustomPaging totalCount={totalCount} />
                <FilteringState
                  onFiltersChange={onFilterChange}
                  // defaultFilters={defaultFilters}
                  columnExtensions={filteringStateColumnExtensions}
                />
                <IntegratedFiltering />
                <Table />
                <TableColumnResizing
                  columnWidths={columnWidths}
                  onColumnWidthsChange={setColumnWidths}
                />
                <TableHeaderRow showSortingControls />
                {/* <TableFilterRow /> */}
                <PagingPanel pageSizes={pageSizes} />
                <Toolbar />
                {/* <SearchPanel /> */}
                {loading && <Loading />}
              </Grid>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </AuditIndex>
  );
}